export function parseYearMonth(
  year: unknown,
  month: unknown
): { year: number; month: number } | null {
  const integer = (value: unknown) =>
    typeof value === "number"
      ? value
      : typeof value === "string" && /^\d+$/.test(value.trim())
        ? Number(value.trim())
        : NaN;
  const y = integer(year);
  const m = integer(month);
  return Number.isInteger(y) &&
    y >= 2000 &&
    y <= 2100 &&
    Number.isInteger(m) &&
    m >= 1 &&
    m <= 12
    ? { year: y, month: m }
    : null;
}
